export class Channel {
  id: string;
  name: string;
  photo: string;
}
